
import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import messagingService from 'services/MessagingService/MessagingService';
import { UPDATE_BALANCE } from 'services/MessagingService/EventNames';
import UserStore from 'stores/UserStore';
import parseCatch from 'utils/parseCatch';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
const TIPPING_BASE_URL = ConfigurationService.get(ConfigurationKeys.TIPPING_BASE_URL);

const GET_PERFORMER_VIDEOS = `${BASE_URL}/rest/v1.0/marketplace/videos`;
const LIKE_VIDEO = `${BASE_URL}/rest/v1.0/marketplace/videos/like/{id}`;
const UNLIKE_VIDEO = `${BASE_URL}/rest/v1.0/marketplace/videos/unlike/{id}`;
const BUY_ALL = `${BASE_URL}/rest/v1.0/marketplace/purchases/videos`;
const GET_PLAY_URL = `${BASE_URL}/rest/v1.0/marketplace/videos/{id}/videoPlay`;
const ADD_LIBRARY = `${BASE_URL}/rest/v1.0/marketplace/libraries/videos/{id}`;
const BUY_VIDEO = `${BASE_URL}/rest/v1.0/marketplace/purchases/videos/{id}`;
const TIPPING_POLLING_URL = `${TIPPING_BASE_URL}/tipper/tipping.user.php`;

class MyShopService {
  constructor() {
    this.messagingService = messagingService();
  }

  getPerformerVideos = (username, sortBy, limit) => {
    const query = {
      userName: username,
      sortBy,
      status: 'APPROVED',
    };

    if (limit && limit > 0) {
      query.limit = limit;
    }

    return ApiService.get(encodeURI(GET_PERFORMER_VIDEOS), { params: query }).then((res) => {
      const data = {
        videos: res.data,
        totalCount: res.headers.totalcount && res.headers.totalcount,
      };

      return data;
    });
  };

  getUpdatedBalance = () => {
    const { user: { username, accessHash } } = UserStore;
    const params = {
      operation: 'getBalance',
      'user_id': username,
      key: accessHash,
    };
    const url = `${TIPPING_POLLING_URL}?params=${JSON.stringify(params)}`;
    ApiService.get(url, { withCredentials: false })
      .then((res) => {
        this.messagingService.emit(UPDATE_BALANCE, parseInt(res.data.userbalance, 10));
      })
      .catch((error) => parseCatch(error));
  };

  getBuyAll = (performer) => ApiService.get(BUY_ALL, { params: { performer } }).then((res) => res.data);

  buyAll = (performer) => ApiService.post(BUY_ALL, { params: { performer } }).then((res) => res.data);

  likeVideo = (id) => {
    const URL = encodeURI(ApiService.substitute(LIKE_VIDEO, { id }));

    return ApiService.put(URL);
  };

  unlikeVideo = (id) => {
    const URL = encodeURI(ApiService.substitute(UNLIKE_VIDEO, { id }));

    return ApiService.delete(URL);
  };

  getPlayUrl = (id) => {
    const URL = encodeURI(ApiService.substitute(GET_PLAY_URL, { id }));

    return ApiService.get(URL).then((res) => res.data);
  };

  addToLibrary(id) {
    const URL = encodeURI(ApiService.substitute(ADD_LIBRARY, { id }));

    return ApiService.post(URL).then((res) => res.data);
  }

  buyVideo(id) {
    const URL = encodeURI(ApiService.substitute(BUY_VIDEO, { id }));

    return ApiService.post(URL).then((res) => res.data);
  }
}

export default new MyShopService();
